// extracted by mini-css-extract-plugin
export default {"checkbox":"MobileNumberSignIn_checkbox__G4mNW","checkmark1":"MobileNumberSignIn_checkmark1__OY8UB"};